// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
import React from "react";

export default function Terms() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Terms & Conditions</h1>
      <p>Last updated: {new Date().getFullYear()}</p>

      <h2>Use of the Site</h2>
      <p>
        StockVisualize provides stock visualisation tools for informational
        purposes only. Nothing on this site constitutes financial advice.
      </p>

      <h2>Accuracy of Information</h2>
      <p>
        We make reasonable efforts to ensure data accuracy but provide no
        guarantee. Use the site at your own risk.
      </p>

      <h2>Limitations of Liability</h2>
      <p>
        We are not liable for any losses or damages arising from the use of this
        website or reliance on its content.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        We may update these Terms occasionally. Continued use of the site
        implies acceptance of the updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions regarding these Terms can be sent to:
        <br />
        <strong>stock.visualise@gmail.com.com</strong>
      </p>
    </div>
  );
}
// <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
